<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Kombineret" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Type" v-model="entity.compound_type_id" :options="subTypes" optionValueName="id" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
					<employee-select-view v-model="entity" label="Ansvarlig" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<form-line-layout>
						<date-select-view label="Fra" v-model="entity.due_start" :controller="$store.state.popupController" />
						<clock-select-view v-model="entity.from" :controller="$store.state.popupController" />
					</form-line-layout>
					<form-line-layout>
						<date-select-view label="Til" v-model="entity.due_end" :controller="$store.state.popupController" />
						<clock-select-view v-model="entity.to" :controller="$store.state.popupController" />
					</form-line-layout>
					<div class="side-window__heading">
						Send SMS påmindelse dagen før
						<switch-view v-model="entity.reminder" />
					</div>
				</div>
				<div v-show="active == 'details'">
					<text-view label="Bemærkninger" :height="200" :optional="true" v-model="entity.remarks" />
				</div>
				<address-view v-show="active == 'address'" v-model="entity.details.address" />
				<div v-show="active == 'files'">
					<file-list-view v-model="entity.details.files" />
				</div>
				<div v-show="active == 'requirements'">
					<requirements-view v-model="entity.requirements" />
				</div>
				<div v-show="active == 'photos'">
					<photos-view v-model="entity.details.photos" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import MoveTaskModel from '../model/MoveTask'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import AddressView from '../views/AddressView';

	import merge from '../functions/merge'
 
	const stop = {

	};

	export default {
		data: function () {
			return {
				packaging: [],
				ORDER: [],
				active: 'details',
				instructions: [],
				departments: [],
				subTypes: []
			};
		},
		watch: {
			'entity.from': function (n) {
				if (n > this.entity.to) {
					this.entity.to = n;
				}
			},
			'entity.to': function (n) {
				if (n < this.entity.from) {
					this.entity.from = n;
				}
			},
			'entity.due_from': function (n) {
				this.entity.end = n;
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'requirements',
						label: 'Behov'
					},
					{
						name: 'files',
						label: 'Filer'
					},
					{
						name: 'photos',
						label: 'Fotos'
					}
				];
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function () {}
			},
			entity: {
				type: Object,
				default() {
					return Object.assign({}, MoveTaskModel);
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(this.entity);
			}
		},
		mounted: function() {
			
			

			var self = this;

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/tasks/compound-types/')
				.then(function (r) {
					self.subTypes = r.data._items;
					//self.departments = r.data._items;
				});

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
